
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 10.625a4.798 4.798 0 01-4.792-4.792A4.798 4.798 0 0110 1.042a4.798 4.798 0 014.792 4.791A4.798 4.798 0 0110 10.625zm0-8.333a3.55 3.55 0 00-3.542 3.541A3.55 3.55 0 0010 9.375a3.55 3.55 0 003.542-3.542A3.55 3.55 0 0010 2.292zM17.159 18.958a.63.63 0 01-.625-.625c0-2.875-2.934-5.208-6.534-5.208-3.6 0-6.533 2.333-6.533 5.208a.63.63 0 01-.625.625.63.63 0 01-.625-.625c0-3.558 3.491-6.458 7.783-6.458s7.784 2.9 7.784 6.458a.63.63 0 01-.625.625z","fill":"#fff"}})])
          )
        }
      }
    